exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-to-top {\n    position: fixed;\n    bottom: 15px;\n    right: 15px;\n    opacity: 0;\n    transition: all .2s ease-in-out;\n}\n\n.scroll-to-top > button {\n    border-radius: 50px;\n    height: 44px;\n    width: 44px;\n    background-color: rgb(1 30 65 / 80%);\n    color: white;\n}\n\n.scroll-to-top > button:focus {\n    outline: 0 !important;\n}\n\n.show-scrollTop {\n    opacity: 1;\n    transition: all .2s ease-in-out;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/scroll-to-top/scroll-to-top.css
// module id = ../../../../../src/app/scroll-to-top/scroll-to-top.css
// module chunks = main